import { setLanguage, setTranslations, queryMappedTranslations, ipCountryQuery, configQuery, getLanguageForCountry } from '@gig/magic-common';
import { LANGUAGE_QUERY, SINGLE_LANGUAGE_QUERY, LANGUAGE_COMMAND_CHANGE, LANGUAGE_UPDATED, VUE_I_18N_QUERY } from '@gig/magic-messages';
import { magic } from '@gig/magic-sdk';
import VueI18n from 'vue-i18n';
import { Language } from '@gig/magic-sdk/dist/adapter/users/language';
import Vue from 'vue';

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const USER_LANGUAGE_KEY = "pw-user-language";
class LanguageService {
  constructor() {
    this.isSingleLanguage = false;
    this.detectLanguage().then((language) => {
      this.language = language;
      Vue.use(VueI18n);
      this.i18n = new VueI18n({
        messages: {
          en: {}
        },
        locale: this.language,
        fallbackLocale: Language.ENGLISH
      });
      this.registerHandlers();
      this.initialize();
    });
  }
  detectLanguage() {
    return __async(this, null, function* () {
      var _a;
      const [country, lockedCountries, languages] = yield Promise.all([
        ipCountryQuery(),
        configQuery("countries.lockedCountries"),
        configQuery("languages")
      ]);
      this.isSingleLanguage = ((_a = languages == null ? void 0 : languages.available) == null ? void 0 : _a.length) === 1;
      if (this.isSingleLanguage && (languages == null ? void 0 : languages.available)) {
        return languages.available[0];
      }
      if (country && lockedCountries.indexOf(country) > -1) {
        return getLanguageForCountry(country);
      }
      const localStorageLang = window.localStorage.getItem(USER_LANGUAGE_KEY);
      let lang = localStorageLang ? localStorageLang : getLanguageForCountry(country);
      const user = magic.session.getUser();
      if (user) {
        lang = user.lang;
      }
      const urlRegexp = new RegExp(`^/(${languages.available.join("|")})(/|$)`);
      const groups = window.location.pathname.match(urlRegexp);
      if (groups && groups[1]) {
        lang = groups[1];
      }
      if (!lang || languages.available.indexOf(lang.toLowerCase()) === -1) {
        lang = languages.default;
      }
      return lang.toLowerCase();
    });
  }
  registerHandlers() {
    window.queryBus.subscribe(LANGUAGE_QUERY, () => {
      return this.language;
    });
    window.queryBus.subscribe(SINGLE_LANGUAGE_QUERY, () => {
      return this.isSingleLanguage;
    });
    window.commandBus.subscribe(LANGUAGE_COMMAND_CHANGE, (event) => __async(this, null, function* () {
      if (!event.payload) {
        console.warn("Missing language in the payload");
        return;
      }
      this.language = event.payload;
      setLanguage(this.language);
      this.saveUserLanguage(this.language);
      this.publishLanguage();
    }));
    window.commandBus.register(LANGUAGE_COMMAND_CHANGE, {
      type: "string",
      enum: Object.values(Language)
    });
    window.eventBus.register(LANGUAGE_UPDATED, {
      type: "string",
      enum: Object.values(Language)
    });
  }
  initialize() {
    setLanguage(this.language);
    setTranslations({});
    this.publishLanguage().then(() => {
      window.queryBus.subscribe(VUE_I_18N_QUERY, () => {
        return this.i18n;
      });
    });
  }
  publishLanguage() {
    window.eventBus.publish(LANGUAGE_UPDATED, this.language);
    return this.updateTranslations();
  }
  updateTranslations() {
    return __async(this, null, function* () {
      const translations = yield queryMappedTranslations();
      this.i18n.locale = this.language;
      this.i18n.setLocaleMessage(this.language, translations);
      setTranslations(this.i18n.messages[this.language]);
    });
  }
  saveUserLanguage(lang) {
    return __async(this, null, function* () {
      const user = magic.session.getUser();
      if (user) {
        yield magic.methods.users.updateLanguage(lang);
      }
    });
  }
}
function i18nQuery() {
  return __async(this, null, function* () {
    return yield window.queryBus.query(VUE_I_18N_QUERY);
  });
}

export { LanguageService, USER_LANGUAGE_KEY, i18nQuery };
